class TableCanvasViewTest {
    tableCanvasView = null
    constructor() {
        window.TableCanvasViewTest = this
    }
    /**
     * @returns TableCanvasViewTest
     */
    static instance = () => {
        return window.TableCanvasViewTest
    }
    init = (tableCanvasView) => {
        this.tableCanvasView = tableCanvasView
    }
    selectTable = (tableName) => {
        let table = this.tableCanvasView.seatLayoutTables.find(table => table.name == tableName)
        if (table) {
            table.onSelected()
        }
    }
}

if (!window.TableCanvasViewTest) {
    window.TableCanvasViewTest = new TableCanvasViewTest()
}

export default TableCanvasViewTest.instance()